export default "__VITE_ASSET__6OzBb8b3__"